var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/dependencyModelUpdatedEvent.ts";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.some.js";
import { sample, combine } from 'effector';
import { prop } from 'ramda';
import { isNotEmpty } from '@gmini/utils';
import * as api from '@gmini/sm-api-sdk';
import { isBaseClassifierNode, isBimModelReferenceNode } from "../classifier-service/Node";
import { getNode, getChildren } from "../classifier-service";
export function createDependencyModelUpdatedEvent(_ref) {
  var notification = _ref.notification,
      currentEntity$ = _ref.currentEntity$,
      nodes$ = _ref.nodes$;
  var modelUpdated = notification.filter({
    fn: api.NotificationEvent.Update.is
  }).map(prop('payload')).filter({
    fn: api.BimModel.is
  });
  return sample({
    ɔ: [{
      clock: modelUpdated,
      source: combine({
        ɔ: [{
          cls: currentEntity$,
          nodes: nodes$
        }],
        config: {
          name: "source",
          sid: "-1jvg25"
        }
      }),
      fn: function fn(_ref2, modelFromEvent) {
        var cls = _ref2.cls,
            nodes = _ref2.nodes;

        var hasChildModel = function hasChildModel(sources) {
          var classifierModelsAsDeps = sources.map(function (ref) {
            return getNode(nodes, ref);
          }).filter(isNotEmpty).filter(isBaseClassifierNode).reduce(function (acc, node) {
            var models = getChildren(nodes, node).filter(isBimModelReferenceNode).map(function (reference) {
              return getNode(nodes, reference.element);
            }).filter(isNotEmpty);
            models.forEach(function (model) {
              acc.push(model);
            });
            return acc;
          }, []);
          return classifierModelsAsDeps.some(function (_ref3) {
            var id = _ref3.id;
            return id === modelFromEvent.id;
          });
        };

        if (cls && hasChildModel(cls.sourceClassifiers)) {
          return {
            clsId: cls.id,
            clsVersion: cls.version,
            modelFromEvent: modelFromEvent
          };
        }

        return null;
      }
    }],
    config: {
      sid: "roux2o"
    }
  }).filter({
    fn: isNotEmpty
  });
}